<script setup lang="ts">
import AgentDirectorySearchPlane from '@/components/AgentSearchBar/AgentDirectorySearchPlane.vue';
</script>

<template>
  <div :class="$style.heroBannerWrapper">
    <div class="layout-container">
      <AgentDirectorySearchPlane />
    </div>
  </div>
</template>

<style lang="scss" module>
@use '@/assets/variables' as *;

.heroBannerWrapper {
  background-color: $color-white;
}
</style>
